import dayjs, { Dayjs } from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(localizedFormat);
dayjs.extend(timezone);

export const getReadableDiff = (start: Dayjs) => {
  const now = dayjs();
  const diff = start.diff(now, 'minute');

  const days = diff > 60 * 24 ? Math.floor(diff / 60 / 24) : 0;
  const hours = diff > 60 ? Math.floor((diff - days * 24 * 60) / 60) : 0;
  const minutes = diff > 0 ? diff - days * 24 * 60 - hours * 60 : 0;

  let parts = [];
  if (days) parts.push(`${days} day${days > 1 ? 's' : ''}`);
  if (hours) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  if (!days && minutes)
    parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`); // Only add minutes if there are no days

  return parts.join(' ');
};
